const en = {
  'nav.home': 'Home',
  'nav.features': 'Benefits',
  'nav.services': 'Services',
  'nav.process': 'Process',
  'nav.faq': 'FAQ',
  'buttons.contact': 'Contact Us',

  'hero.badge': 'Development Partner',
  'hero.title.prefix': 'Empower your business with',
  'hero.title.highlight': 'tailor‑made digital solutions',
  'hero.subtext': 'We build products and apps with agile cycles, transparency and a focus on outcomes. From discovery to publishing, we handle every technical detail.',
  'hero.bullets.process': 'Agile cycles',
  'hero.bullets.deliveries': 'Frequent deliveries',
  'hero.bullets.security': 'Quality & security',
  'hero.cta.primary': 'Talk to a Specialist',

  'features.heading': 'Why choose Gruty?',
  'features.description': 'Agile processes, transparent partnership and custom solutions oriented to results.',
  'features.items.systems.title': 'Tailor‑made',
  'features.items.systems.desc': 'Development aligned to your goals and business context.',
  'features.items.integrations.title': 'Continuous agility',
  'features.items.integrations.desc': 'Short cycles with continuous, predictable deliveries.',
  'features.items.backups.title': 'Transparency & Partnership',
  'features.items.backups.desc': 'Constant alignment, clear communication and progress tracking.',
  'features.items.delivery.title': 'Outcome Focus',
  'features.items.delivery.desc': 'Metrics and impact guiding each delivery.',
  'features.items.observability.title': 'Quality & Security',
  'features.items.observability.desc': 'Best practices, tests and observability from day one.',
  'features.items.payments.title': 'Publishing & Scale',
  'features.items.payments.desc': 'DevOps, stores and infrastructure to grow confidently.',

  'services.heading': 'Services',
  'services.description': 'From pre‑project to publishing, we cover the full digital product cycle.',
  'services.items.web.title': 'Web Development',
  'services.items.web.desc': 'Modern, responsive websites and web apps optimized for conversion.',
  'services.items.mobile.title': 'Mobile Apps',
  'services.items.mobile.desc': 'Native and hybrid apps for iOS and Android with outstanding performance.',
  'services.items.backend.title': 'Integrations & APIs',
  'services.items.backend.desc': 'Reliable integrations with ERPs, CRMs, gateways and external services.',
  'services.items.consulting.title': 'UX/UI Design',
  'services.items.consulting.desc': 'Intuitive, engaging experiences focused on usability.',
  'services.items.preproject.title': 'Pre‑project',
  'services.items.preproject.desc': 'Well‑defined goals, scope and requirements to start with clarity.',
  'services.items.devops.title': 'DevOps & Publishing',
  'services.items.devops.desc': 'Pipeline, stores and infrastructure to launch and scale securely.',

  'cta.heading': 'Ready to accelerate your product?',
  'cta.description': 'Let’s build your app with agile cycles, quality and a focus on outcomes.',
  'cta.primary': 'Talk to a Specialist',
  'cta.secondary': 'See Success Stories',

  'footer.description.line1': 'We build tailor‑made digital solutions with agile cycles.',
  'footer.description.line2': 'Technical excellence, partnership and outcome focus.',
  'footer.copyright': '© 2024 Gruty Software. All rights reserved.',

  'process.heading': 'Our Process',
  'process.description': 'Clear stages, frequent deliveries and continuous alignment from start to publishing.',
  'process.steps.1.title': 'Discovery',
  'process.steps.1.desc': 'Understanding context, goals and business challenges.',
  'process.steps.2.title': 'Pre‑project',
  'process.steps.2.desc': 'Scope, requirements and goals defined with clarity.',
  'process.steps.3.title': 'UX/UI Design',
  'process.steps.3.desc': 'Wireframes and interfaces focused on usability.',
  'process.steps.4.title': 'Development',
  'process.steps.4.desc': 'Iterative implementation with agile cycles.',
  'process.steps.5.title': 'Quality (QA)',
  'process.steps.5.desc': 'Tests, fixes and active observability.',
  'process.steps.6.title': 'Publishing',
  'process.steps.6.desc': 'Delivery, stores and infrastructure ready to scale.',
  'process.steps.7.title': 'Continuous evolution',
  'process.steps.7.desc': 'Improvements guided by metrics and feedback.',

  'faq.heading': 'Frequently Asked Questions',
  'faq.description': 'Questions about our services and processes.',
  'faq.items.1.title': 'How do your delivery cycles work?',
  'faq.items.1.content': 'We work in 2-week sprints, with client demos, weekly written updates and real-time access to the task board.',
  'faq.items.2.title': 'Do you offer support after publishing?',
  'faq.items.2.content': 'Yes. We offer monthly support packages with defined SLA, 24/7 monitoring and a metrics-driven evolution roadmap.',
  'faq.items.3.title': 'Can you integrate with other systems?',
  'faq.items.3.content': 'Yes. We integrate with APIs, ERPs, CRMs, payment gateways and external services.',
  'faq.items.4.title': 'How do you handle security and quality?',
  'faq.items.4.content': 'We apply best practices, tests and monitoring from the start.',
  'faq.items.5.title': 'What is the average project timeline?',
  'faq.items.5.content': 'Simple projects: 4–8 weeks. Complex systems: 3–6 months. Every project starts with a 1-week pre-project to define the exact scope.',
  'faq.items.6.title': 'Do you work on international projects?',
  'faq.items.6.content': 'Yes. We serve Brazil and abroad, with communication in Portuguese and English.',

  'budget.projectDescription': 'Describe your project (optional)',
  'budget.projectDescriptionPlaceholder': 'Tell us a bit about what you need to build...',
};

export default en;
